import { z } from "zod";

const apiRepresentation3dSchema = z.object({
    representationType: z.string(),
    materialId: z.number().nullable(),
  });

export default apiRepresentation3dSchema;